module.exports = __webpack_public_path__ + "img/bj_2.52da8596.png";